(function () {
    'use strict';

    angular
        .module('app')
        .factory('EmailTemplatesService', EmailTemplatesService);

    EmailTemplatesService.$inject = ['$http', '$q', 'UrlService', 'DataService'];

    /**
     * @ngdoc service
     * @name EmailTemplatesService
     *
     * @description
     * Data service for email templates.
     */
    function EmailTemplatesService($http, $q, UrlService, DataService) {
        var service = DataService('emailtemplate');

        service.multiCopy = multiCopy;
        service.multiDelete = multiDelete;
        service.count = count;

        return service;

        /**
         * Deletes the specified email templates
         *
         * @param {array} emailTemplateIds - An array of email template ids for the email templates to be deleted.
         * @return {promise} A promise resolved once the email template deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(emailTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/emailtemplatedelete', emailTemplateIds);
        }

        /**
         * Create copies of the specified email templates.
         *
         * @param {array} emailTemplateIds - An array of email template ids for the email templates to be copied.
         * @return {promise} A promise resolved once the email template copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(emailTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/emailtemplatecopy', emailTemplateIds);
        }

        /**
         * Gets the count of email templates
         *
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(deleted) {
            var url = UrlService.getWebAPIUrl() + '/emailtemplate/count';

            if (!_.isNil(deleted)) {
                url += '?deleted=' + deleted;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();